
	 
    import { Options, Vue  } from "vue-class-component";  
     
    @Options({
        name: "SigapIndex",
        components: {    },  
    }) 
    export default class SigapIndex extends Vue {
         
    }
  
